/**
 * @file Route: home
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "./index.scss";
import "layouts/main";

import { Slider } from "components/Slider";
import { ShopBy } from "components/ShopBy";
import { CategoryFeatured } from "components/Category/Featured";
import { ProductSpecial } from "components/Product/Special";
import { ProductCard } from "components/Product/Card"


console.log("Route home/index.js mounted.");

Slider();
ShopBy();
CategoryFeatured();
ProductSpecial();
ProductCard();